export function limitConcurrent(max: number) {
  if (!Number.isInteger(max) || max < 1) {
    throw new Error('max must be an integer greater than or equal to 1');
  }

  let active = 0;
  const queue: Array<() => void> = [];

  function drain() {
    while (active < max && queue.length > 0) {
      const run = queue.shift()!;
      run();
    }
  }

  return function limit<T>(task: () => Promise<T> | T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const run = () => {
        active++;
        Promise.resolve()
          .then(task)
          .then(resolve, reject)
          .finally(() => {
            active--;
            drain();
          });
      };

      queue.push(run);
      drain();
    });
  };
}
